import gql from 'graphql-tag';

export const LOG_ACTION = gql`
    mutation LogRoute($action: inUserAction) {
        logUserAction(action: $action) {
            _id
        }
    }
`;
